export const prices = [
  {
    name: "Any",
    min: 0,
    max: 0,
  },
  {
    name: `$1 to $10`,
    min: 1,
    max: 10,
  },
  {
    name: `$10 to $100`,
    min: 10,
    max: 100,
  },
  {
    name: `$100 to $1000`,
    min: 100,
    max: 1000,
  },
];
export const ratings = [
  {
    name: "4stars & up",
    rating: 4,
  },

  {
    name: "3stars & up",
    rating: 3,
  },

  {
    name: "2stars & up",
    rating: 2,
  },

  {
    name: "1stars & up",
    rating: 1,
  },
];

export const reportperiod = [
  {
    financialyear: "Financial Year 2018",
    fromdate: "01/03/2018",
    todate: "28/02/2019",
  },
  {
    financialyear: "Financial Year 2019",
    fromdate: "01/03/2019",
    todate: "28/02/2020",
  },
  {
    financialyear: "Financial Year 2020",
    fromdate: "01/03/2020",
    todate: "28/02/2021",
  },
  {
    financialyear: "Financial Year 2021",
    fromdate: "01/03/2021",
    todate: "28/02/2022",
  },
];

export const convertStringToDate = (inputstr) => {
  //inputstring: mm/dd/yyyy
  const stringarray = inputstr.split("/");
  var iterator = stringarray.values();
  const mm = iterator.next().value;
  const dd = iterator.next().value;
  const yyyy = iterator.next().value;
  const datestr = yyyy + "-" + mm + "-" + dd;
  console.log("datestr: " + datestr);
  const resultdate = new Date(datestr);
  return datestr;
};
